module.exports = __webpack_public_path__ + "static/img/Aacteacher3.eb7375b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher3.png
// module id = xgMG
// module chunks = 1